import React, { FC, useMemo } from 'react'
// components
import MailRounded from 'components/svgComponent/MailRounded'
import SmallLogoMenu from 'components/svgComponent/SmallLogoMenu'
import LinkFacebook from 'components/svgComponent/LinkFacebook'
import LinkX from 'components/svgComponent/LinkX'
import LinkYoutube from 'components/svgComponent/LinkYoutube'
import LinkInstagram from 'components/svgComponent/LinkInstagram'
// types
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'

interface Props {
  classes: Classes
  style?: React.CSSProperties
}

const Footer: FC<Props> = ({ classes }) => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  const currentYear = useMemo(() => new Date().getFullYear(), [])

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        {/* About */}
        <div className={classes.col}>
          <div className={classes.brand} onClick={scrollToTop} role="button" tabIndex={0}>
            <SmallLogoMenu width={64} height={64} />
            <span className={classes.brandTitle}>Skilent</span>
          </div>

          <p className={classes.aboutText}>
            Our aim is to provide a new and exciting platform to efficiently source jobs and
            candidates by offering Bounty Points for true Crowdsource recruiting!
          </p>
        </div>

        {/* Important Links */}
        <nav className={classes.col} aria-label="Important Links">
          <h5 className={classes.heading}>Important Links</h5>
          <ul className={classes.links}>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/">About Us</a>
            </li>
            <li>
              <a href="/">Search Jobs</a>
            </li>
            <li>
              <a href="/">Support</a>
            </li>
            <li>
              <a href="/">FAQ</a>
            </li>
            <li>
              <a href="/">Contact Us</a>
            </li>
          </ul>
        </nav>

        {/* Connect With Us */}
        <div className={classes.col}>
          <h5 className={classes.heading}>Connect With Us</h5>
          <ul className={classes.contactList}>
            <li className={classes.mailRow}>
              <MailRounded />
              <a href="mailto:info@skilent.com">info@skilent.com</a>
            </li>
          </ul>

          {/* Socials */}
          <ul className={classes.socials} aria-label="Social links">
            <li>
              <a className={classes.socialBtn} href="#" aria-label="Facebook" title="Facebook">
                <LinkFacebook />
              </a>
            </li>
            <li>
              <a
                className={classes.socialBtn}
                href="#"
                aria-label="X (Twitter)"
                title="X (Twitter)"
              >
                <LinkX />
              </a>
            </li>
            <li>
              <a className={classes.socialBtn} href="#" aria-label="YouTube" title="YouTube">
                <LinkYoutube />
              </a>
            </li>
            <li>
              <a className={classes.socialBtn} href="#" aria-label="Instagram" title="Instagram">
                <LinkInstagram />
              </a>
            </li>
          </ul>

          {/*<ul className={classes.socials}>*/}
          {/*  <li>*/}
          {/*    <a href="javascript:void(0)" aria-label="Facebook">*/}
          {/*      Facebook*/}
          {/*    </a>*/}
          {/*  </li>*/}
          {/*  <li>*/}
          {/*    <a href="javascript:void(0)" aria-label="Twitter">*/}
          {/*      Twitter*/}
          {/*    </a>*/}
          {/*  </li>*/}
          {/*  <li>*/}
          {/*    <a href="javascript:void(0)" aria-label="LiveJournal">*/}
          {/*      LiveJournal*/}
          {/*    </a>*/}
          {/*  </li>*/}
          {/*</ul>*/}
        </div>
      </div>

      <div className={classes.divider} />

      <div className={classes.bottomRow}>
        <span className={classes.copyright}>
          Copyright © Skilent {currentYear}, Skilent&trade; and its related IP are registered
          offerings of the creators. All Rights Reserved.
        </span>
      </div>
    </footer>
  )
}

export default injectSheet(sheet)(Footer)
